export default __webpack_public_path__ + "static/media/logo.e1179a07.png";